import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { MediaGateway, AdaptedMediaGateway } from 'data/mediaGateway/mediaGateway.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  MediaGatewayData: AdaptedMediaGateway,
  originalMediaGatewayFormData: MediaGateway | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.MEDIA_GATEWAY_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.MEDIA_GATEWAY_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(MediaGatewayData, null, isEdit, originalMediaGatewayFormData),
    MediaGatewayData.name,
    AuditService.MEDIA_GATEWAY,
    actionType,
  );
  return auditDetails as AuditDetails;
}
